module.exports = __webpack_public_path__ + "img/ifyouleave.9c59a2b5.jpg";